import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, MenuItem, FormControl, InputLabel, Select, Grid, Button } from '@mui/material';
import { useFormTheme } from '../../../contexts/FormThemeContext'; // Adjust the import path as necessary

const PaperThemeView = () => {
  const [dropdownValue, setDropdownValue] = useState(10); // Pre-select "Option 1"
  const { colors, fonts, fieldVariant, submitButtonStyle } = useFormTheme(); // Access the submit button style from context
//  console.log('[PaperThemeView] Current button style:', submitButtonStyle); // Add this line for debugging

  const handleDropdownChange = (event) => {
    setDropdownValue(event.target.value);
  };

  const buttonContainerStyle = {
    display: 'flex',
    justifyContent: submitButtonStyle.alignment, // This will adjust based on alignment: 'left', 'center', 'right'
    width: '100%', // Ensure the container takes full width
    padding: 3
  };

  return (
    <Box sx={{
      p: 3,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'start',
      height: '100%',
      minHeight: '100vh',
      backgroundColor: colors.backgroundColor,
    }}>
      <Paper elevation={3} sx={{
        width: '90%',
        padding: 3,
        minHeight: '100vh',
        backgroundColor: '#ffffff', // Ensure the inside of Paper is white
        color: colors.textColor, // Text color for the content inside Paper
      }}>
        <Typography variant="h4" gutterBottom style={{ color: colors.textColor, fontFamily: fonts.primaryFont }}>
          Header
        </Typography>
        <Typography variant="h6" gutterBottom style={{ color: colors.textColor, fontFamily: fonts.primaryFont }}>
          Subheader
        </Typography>
        <Typography variant="body1" gutterBottom style={{ color: colors.textColor, fontFamily: fonts.secondaryFont }}>
          This is an example paragraph that provides details about the form.
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="This is an Active Field Example"
              defaultValue="text color"
              helperText="This field is not interactive."
              variant={fieldVariant}
              fullWidth
              margin="normal"
              InputProps={{
                readOnly: true,
                style: { color: colors.textColor, fontFamily: fonts.secondaryFont } // Apply text color here
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: colors.activeColor, // Always display active color for the border
                  },
                },
                '& .MuiInputLabel-root': {
                  color: colors.activeColor, // Always display active color for the label
                },
                '& .MuiInput-underline:before': {
                  borderBottomColor: colors.activeColor, // Always display active color for underline
                },
                '& .MuiInput-underline:after': {
                  borderBottomColor: colors.activeColor, // Always display active color for underline after input
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Field with Warning"
              defaultValue="warning example"
              helperText="This is an example of an error."
              variant={fieldVariant}
              error
              fullWidth
              margin="normal"
              InputProps={{
                readOnly: true,
                style: { color: colors.warningColor, fontFamily: fonts.secondaryFont }
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&.Mui-focused fieldset': {
                    borderColor: colors.warningColor,
                  },
                  '& fieldset': {
                    borderColor: colors.warningColor,
                  }
                },
                '& .MuiFormHelperText-root': {
                  color: colors.warningColor,
                }
              }}
            />
          </Grid>
        </Grid>

        <FormControl fullWidth margin="normal">
          <InputLabel
            id="example-select-label"
            sx={{
              color: colors.textColor, // Default (inactive) label color
              fontFamily: fonts.secondaryFont,
              '&.Mui-focused': {
                color: colors.activeColor, // Active label color when focused
              },
            }}
          >
            Example Dropdown
          </InputLabel>
          <Select
            labelId="example-select-label"
            id="example-select"
            value={dropdownValue}
            label="Example Dropdown"
            onChange={handleDropdownChange}
            variant={fieldVariant}
            sx={{
              fontFamily: fonts.secondaryFont,
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: colors.textColor, // Default (inactive) border color
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: colors.activeColor, // Hover border color
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: colors.activeColor, // Active border color when focused
              },
            }}
          >
            <MenuItem value={10} style={{ fontFamily: fonts.secondaryFont }}>
              Option 1
            </MenuItem>
            <MenuItem value={20} style={{ fontFamily: fonts.secondaryFont }}>
              Option 2
            </MenuItem>
          </Select>
        </FormControl>

        {/* Submit Button with styles from FormThemeContext */}
        <Box sx={buttonContainerStyle}>
          <Button
            variant="contained"
            color="primary"
            style={{
              backgroundColor: submitButtonStyle.backgroundColor, // Apply button background color
              color: submitButtonStyle.textColor, // Apply button text color
              fontSize: submitButtonStyle.fontSize, // Ensure fontSize is applied
              fontWeight: submitButtonStyle.fontWeight, // Ensure fontWeight is applied
              width: submitButtonStyle.width, // Ensure width is applied
              height: submitButtonStyle.height, // Ensure height is applied
              borderRadius: submitButtonStyle.borderRadius, // Ensure borderRadius is applied
              fontFamily: submitButtonStyle.fontFamily, // Apply button fontFamily
              borderColor: submitButtonStyle.borderColor, // Apply button border color
              borderWidth: submitButtonStyle.borderWidth, // Apply button border width
              borderStyle: submitButtonStyle.borderStyle, // Apply button border style
              boxShadow: submitButtonStyle.boxShadow, // Apply button box shadow if any
              textTransform: submitButtonStyle.textTransform, // Apply text transform (like uppercase, lowercase, etc.)
            }}
          >
            {submitButtonStyle.label}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default PaperThemeView;
